import { isValidObject } from '../../Validity';
import { conversionDescription, dropGoalDescription, foulDescription, penaltyKickDescription, tryDescription } from './RugbyStatDescription';

// ---------------------------------------------------------------------------------------------------------
// Tries
// ---------------------------------------------------------------------------------------------------------

export const ourTriesDescription = (tries: any[]) => {
    if (isValidObject(tries)) {
        return tries.map((rugbyTry: any) => {
            if (rugbyTry.team === 'our') {
                return tryDescription(rugbyTry);
            }
            return null;
        });
    }
    return [];
};

export const opponentTriesDescription = (tries: any[]) => {
    if (isValidObject(tries)) {
        return tries.map((rugbyTry: any) => {
            if (rugbyTry.team === 'opponent') {
                return tryDescription(rugbyTry);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Conversions
// ---------------------------------------------------------------------------------------------------------

export const ourConversionsDescription = (conversions: any[]) => {
    if (isValidObject(conversions)) {
        return conversions.map((conversion: any) => {
            if (conversion.team === 'our') {
                return conversionDescription(conversion);
            }
            return null;
        });
    }
    return [];
};

export const opponentConversionsDescription = (conversions: any[]) => {
    if (isValidObject(conversions)) {
        return conversions.map((conversion: any) => {
            if (conversion.team === 'opponent') {
                return conversionDescription(conversion);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Penalty Kicks
// ---------------------------------------------------------------------------------------------------------

export const ourPenaltyKicksDescription = (conversions: any[]) => {
    if (isValidObject(conversions)) {
        return conversions.map((conversion: any) => {
            if (conversion.team === 'our') {
                return penaltyKickDescription(conversion);
            }
            return null;
        });
    }
    return [];
};

export const opponentPenaltyKicksDescription = (conversions: any[]) => {
    if (isValidObject(conversions)) {
        return conversions.map((conversion: any) => {
            if (conversion.team === 'opponent') {
                return penaltyKickDescription(conversion);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Drop Goals
// ---------------------------------------------------------------------------------------------------------

export const ourDropGoalsDescription = (dropGoals: any[]) => {
    if (isValidObject(dropGoals)) {
        return dropGoals.map((dropGoal: any) => {
            if (dropGoal.team === 'our') {
                return dropGoalDescription(dropGoal);
            }
            return null;
        });
    }
    return [];
};

export const opponentDropGoalsDescription = (dropGoals: any[]) => {
    if (isValidObject(dropGoals)) {
        return dropGoals.map((dropGoal: any) => {
            if (dropGoal.team === 'opponent') {
                return dropGoalDescription(dropGoal);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Fouls
// ---------------------------------------------------------------------------------------------------------

export const ourFoulsDescription = (fouls: any[]) => {
    if (isValidObject(fouls)) {
        return fouls.map((foul: any) => {
            if (foul.team === 'our') {
                return foulDescription(foul);
            }
            return null;
        });
    }
    return [];
};

export const opponentFoulsDescription = (fouls: any[]) => {
    if (isValidObject(fouls)) {
        return fouls.map((foul: any) => {
            if (foul.team === 'opponent') {
                return foulDescription(foul);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Points
// ---------------------------------------------------------------------------------------------------------

export const ourPointsDescription = (tries: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[], fouls: any[]) => {
    const pointsDetails: any[] = [];
    tries.forEach((rugbyTry) => {
        if (rugbyTry.team === 'our') {
            pointsDetails.push(tryDescription(rugbyTry));
        }
    });
    conversions.forEach((conversion) => {
        if (conversion.team === 'our') {
            pointsDetails.push(conversionDescription(conversion));
        }
    });
    penaltyKicks.forEach((penaltyKick) => {
        if (penaltyKick.team === 'our') {
            pointsDetails.push(penaltyKickDescription(penaltyKick));
        }
    });
    dropGoals.forEach((dropGoal) => {
        if (dropGoal.team === 'our') {
            pointsDetails.push(dropGoalDescription(dropGoal));
        }
    });
    fouls.forEach((foul) => {
        if (foul.team === 'our') {
            pointsDetails.push(foulDescription(foul));
        }
    });
    return pointsDetails;
};

export const opponentPointsDescription = (tries: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[], fouls: any[]) => {
    const pointsDetails: any[] = [];
    tries.forEach((rugbyTry) => {
        if (rugbyTry.team === 'opponent') {
            pointsDetails.push(tryDescription(rugbyTry));
        }
    });
    conversions.forEach((conversion) => {
        if (conversion.team === 'opponent') {
            pointsDetails.push(conversionDescription(conversion));
        }
    });
    penaltyKicks.forEach((penaltyKick) => {
        if (penaltyKick.team === 'opponent') {
            pointsDetails.push(penaltyKickDescription(penaltyKick));
        }
    });
    dropGoals.forEach((dropGoal) => {
        if (dropGoal.team === 'opponent') {
            pointsDetails.push(dropGoalDescription(dropGoal));
        }
    });
    fouls.forEach((foul) => {
        if (foul.team === 'opponent') {
            pointsDetails.push(foulDescription(foul));
        }
    });
    return pointsDetails;
};

export const ourPointsDescriptionFromGame = (game: any) => {
    return ourPointsDescription(game.tries, game.conversions, game.penaltyKicks, game.dropGoals, game.fouls);
};

export const opponentPointsDescriptionFromGame = (game: any) => {
    return opponentPointsDescription(game.tries, game.conversions, game.penaltyKicks, game.dropGoals, game.fouls);
};
